export class DonateData {
  id: string;
  name: string;
  donate: number;
  yt: string;
  stime: number;
  time: number;
  msg: string;
  pic1: string;
  pic2: string;
  constructor(
    id: string,
    name: string,
    donate: number,
    yt: string,
    stime: number,
    time: number,
    msg: string,
    pic1: string,
    pic2: string
  ) {
    this.id = id;
    this.name = name;
    this.donate = donate;
    this.yt = yt;
    this.stime = stime;
    this.time = time;
    this.msg = msg;
    this.pic1 = pic1;
    this.pic2 = pic2;
    if (this.id === null) {
      this.id = '';
    }
    if (this.name === null) {
      this.name = '';
    }
    if (this.donate === null) {
      this.donate = 0;
    }
    if (this.yt === null) {
      this.yt = '';
    }
    if (this.stime === null) {
      this.stime = 0;
    }
    if (this.time === null) {
      this.time = 0;
    }
    if (this.msg === null) {
      this.msg = '';
    }
    if (this.pic1 === null) {
      this.pic1 = '';
    }
    if (this.pic1 === null) {
      this.pic2 = '';
    }
  }
}
export class SendDonateData {
  id: string;
  name: string;
  donate: number;
  yt: string;
  stime: number;
  time: number;
  msg: string;
  constructor(
    id: string,
    name: string,
    donate: number,
    yt: string,
    stime: number,
    time: number,
    msg: string,
  ) {
    this.id = id;
    this.name = name;
    this.donate = donate;
    this.yt = yt;
    this.stime = stime;
    this.time = time;
    this.msg = msg;
    if (this.id === null) {
      this.id = '';
    }
    if (this.name === null) {
      this.name = '';
    }
    if (this.donate === null) {
      this.donate = 0;
    }
    if (this.yt === null) {
      this.yt = '';
    }
    if (this.stime === null) {
      this.stime = 0;
    }
    if (this.time === null) {
      this.time = 0;
    }
    if (this.msg === null) {
      this.msg = '';
    }
  }
}
